export const Billogram = {
  UseBillogram: "useBillogram" as const,
  UseBillogramDescription: "useBillogramDescription" as const,
  BillogramAuthUser: "billogramAuthUser" as const,
  BillogramAuthKey: "billogramAuthKey" as const,
  BillogramAccountMappingDetails: "billogramAccountMappingDetails" as const,
  BillogramAccountMappingListItems: "billogramAccountMappingListItems" as const,
}

export const BillogramAccountMappingListItem = {
  Id: "id" as const,
  AccountNumber: "accountNumber" as const,
  CostCenterId: "costCenterId" as const,
  ConstCenterName: "constCenterName" as const,
  ProjectId: "projectId" as const,
  ProjectName: "projectName" as const,
  Key: "key" as const,
}

export const SimpleIntegration = {
  IsActive: "isActive" as const,
  LogingDetails: "logingDetails" as const,
  UserName: "userName" as const,
  ApiKey: "apiKey" as const,
}

export const StripeConnect = {
  UseStripeConnect: "useStripeConnect" as const,
  UseStripeConnectDescription: "useStripeConnectDescription" as const,
}

export const VismaAdvisorConnect = {
  VismaAdvisorAction: "vismaAdvisorAction" as const,
  VismaAdvisorDescription: "vismaAdvisorDescription" as const,
}

export const CustomIntegration = {
  Id: "id" as const,
  IsActive: "isActive" as const,
  Name: "name" as const,
  Description: "description" as const,
  LogingDetails: "logingDetails" as const,
  ApiKey: "apiKey" as const,
  UserName: "userName" as const,
}

